import { useSelector } from "react-redux";
import Footer from "../../components/footer";
import Navbar from "../../components/navbar";
import CampaignList from "./reuseableComponents/campaignList";

const AllCampaigns = () => {
    const loading = useSelector((state) => state.user.loading);
    document.title = `${loading? "Mosquepay" : "Discover campaigns - Mosquepay"}`
    return ( 
        <div className="grid content-between min-h-screen">
          <Navbar />
          <div className="px-4 md:px-12 mt-24 pb-16">
            <CampaignList cardLayout={"grid-cols-1 md:grid-cols-3 lg:grid-cols-4"}/>
          </div>
          <Footer />
        </div>
     );
}
 
export default AllCampaigns;